import { ExternalIcon, LogoutFilledIcon } from '@/components/Icons';
import { useSessionStore } from '@/hooks/useSessionStore';
import { ProfileUserInfo } from '../Profile';
import { useDimensions } from '@/hooks/useDimensions';

const LinksDetail = () => {
  const { session } = useSessionStore();
  const { isMobileOrPad } = useDimensions();
  return (
    <div className="flex h-full flex-col justify-between text-[#48484b]">
      <div className="p-4">
        <a
          className=" block help flex justify-between items-center gap-2 w-fit cursor-pointer"
          href="https://support.jenmusic.ai/en/"
          target="__blank"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21ZM11.2383 16H12.6797C12.7188 16 12.7383 15.9805 12.7383 15.9414V14.4766C12.7383 14.4375 12.7188 14.418 12.6797 14.418H11.2383C11.1992 14.418 11.1797 14.4375 11.1797 14.4766V15.9414C11.1797 15.9805 11.1992 16 11.2383 16ZM9.97852 8.07812C9.48242 8.51172 9.23438 9.06836 9.23438 9.74805V9.86523C9.23438 9.9082 9.25391 9.92969 9.29297 9.92969H10.3184C10.3574 9.92578 10.377 9.9043 10.377 9.86523V9.74805C10.373 9.38477 10.5078 9.07812 10.7812 8.82812C11.0547 8.57812 11.4375 8.45312 11.9297 8.45312C12.4219 8.45312 12.8184 8.59961 13.1191 8.89258C13.4199 9.18555 13.5703 9.50195 13.5703 9.8418C13.5703 10.1816 13.4863 10.459 13.3184 10.6738C13.1465 10.8887 12.7832 11.1133 12.2285 11.3477C11.6738 11.582 11.3965 11.9609 11.3965 12.4844V13.4336C11.3965 13.4727 11.416 13.4922 11.4551 13.4922H12.4746C12.5137 13.4922 12.5332 13.4727 12.5332 13.4336V12.5781C12.5566 12.4336 12.6289 12.3301 12.75 12.2676C13.0234 12.1309 13.2324 12.0234 13.377 11.9453C13.8301 11.6875 14.1484 11.4277 14.332 11.166C14.5742 10.8105 14.6953 10.3867 14.6953 9.89453C14.6953 9.19922 14.4375 8.61523 13.9219 8.14258C13.4062 7.66992 12.7441 7.43359 11.9355 7.43359C11.127 7.43359 10.4746 7.64844 9.97852 8.07812Z"
              fill="#48484B"
            />
          </svg>
          <span>Help and Support</span>
        </a>
      </div>
      <div>
        <div className="p-4 flex flex-col gap-2">
          <a className=" flex justify-between gap-2 w-fit cursor-pointer" href="https://www.jenmusic.ai/privacy-policy" target="__blank">
            <ExternalIcon />
            Privacy Policy
          </a>
          <a className="flex justify-between gap-2 w-fit cursor-pointer" href="https://www.jenmusic.ai/terms-of-use" target="__blank">
            <ExternalIcon />
            Terms and Conditions
          </a>
        </div>
        {isMobileOrPad && (
          <div className="border-t border-jen-border">
            <ProfileUserInfo session={session} />
          </div>
        )}

        <div
          className="p-5 flex gap-2 items-center border-t border-jen-border cursor-pointer"
          onClick={async () => {
            window.location.replace('/logout');
          }}
        >
          <LogoutFilledIcon className="w-5 h-5" fillColor="currentColor" />
          Log out
        </div>
      </div>
    </div>
  );
};
export default LinksDetail;
